/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  BalanceInternal,
  BalanceInternalOptional,
  BalanceInternalMetaI,
  BalanceInternalTrackedI,
} from "./balance-internal";
import {
  BalanceInternalTracked,
  BalanceInternalMeta,
} from "./balance-internal";
// May contain unused imports in some cases
// @ts-ignore
import type {
  BalanceTransactionWithPaymentDTO,
  BalanceTransactionWithPaymentDTOOptional,
  BalanceTransactionWithPaymentDTOMetaI,
  BalanceTransactionWithPaymentDTOTrackedI,
} from "./balance-transaction-with-payment-dto";
import {
  BalanceTransactionWithPaymentDTOTracked,
  BalanceTransactionWithPaymentDTOMeta,
} from "./balance-transaction-with-payment-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  BalanceType,
  BalanceTypeOptional,
  BalanceTypeMetaI,
  BalanceTypeTrackedI,
} from "./balance-type";
import { BalanceTypeTracked, BalanceTypeMeta } from "./balance-type";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonBalanceDTO,
  PersonBalanceDTOOptional,
  PersonBalanceDTOMetaI,
  PersonBalanceDTOTrackedI,
} from "./person-balance-dto";
import {
  PersonBalanceDTOTracked,
  PersonBalanceDTOMeta,
} from "./person-balance-dto";

/**
 *
 * @export
 * @interface BalanceDTO
 */
export interface BalanceDTOOptional extends BalanceInternalOptional {
  /**
   *
   * @type {boolean}
   * @memberof BalanceDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof BalanceDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof BalanceDTO
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof BalanceDTO
   */
  balanceName?: string;
  /**
   *
   * @type {string}
   * @memberof BalanceDTO
   */
  balanceExpirationDate?: Date;
  /**
   *
   * @type {string}
   * @memberof BalanceDTO
   */
  balanceAccountNumber?: string;
  /**
   *
   * @type {boolean}
   * @memberof BalanceDTO
   */
  balanceIsPrivate?: boolean;
  /**
   *
   * @type {BalanceType}
   * @memberof BalanceDTO
   */
  balanceType?: BalanceType;
  /**
   *
   * @type {Array<PersonBalanceDTO>}
   * @memberof BalanceDTO
   */
  personBalances?: PersonBalanceDTOOptional[];
  /**
   *
   * @type {number}
   * @memberof BalanceDTO
   */
  balanceMinimumCents?: number;
  /**
   *
   * @type {Array<BalanceTransactionWithPaymentDTO>}
   * @memberof BalanceDTO
   */
  balanceTransactions?: BalanceTransactionWithPaymentDTOOptional[];
  /**
   *
   * @type {number}
   * @memberof BalanceDTO
   */
  balanceAmountCurrent?: number;
}

export interface BalanceDTO extends BalanceDTOOptional, BalanceInternal {
  /**
   *
   * @type {boolean}
   * @memberof BalanceDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof BalanceDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof BalanceDTO
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof BalanceDTO
   */
  balanceName?: string;
  /**
   *
   * @type {string}
   * @memberof BalanceDTO
   */
  balanceExpirationDate?: Date;
  /**
   *
   * @type {string}
   * @memberof BalanceDTO
   */
  balanceAccountNumber?: string;
  /**
   *
   * @type {boolean}
   * @memberof BalanceDTO
   */
  balanceIsPrivate?: boolean;
  /**
   *
   * @type {BalanceType}
   * @memberof BalanceDTO
   */
  balanceType: BalanceType;
  /**
   *
   * @type {Array<PersonBalanceDTO>}
   * @memberof BalanceDTO
   */
  personBalances?: PersonBalanceDTO[];
  /**
   *
   * @type {number}
   * @memberof BalanceDTO
   */
  balanceMinimumCents?: number;
  /**
   *
   * @type {Array<BalanceTransactionWithPaymentDTO>}
   * @memberof BalanceDTO
   */
  balanceTransactions?: BalanceTransactionWithPaymentDTO[];
  /**
   *
   * @type {number}
   * @memberof BalanceDTO
   */
  balanceAmountCurrent?: number;
}

export interface BalanceDTOTrackedI extends BalanceInternalOptional {
  /**
   *
   * @type {boolean}
   * @memberof BalanceDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof BalanceDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof BalanceDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof BalanceDTO
   */
  balanceName?: string;
  balanceNameIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof BalanceDTO
   */
  balanceExpirationDate?: Date;
  balanceExpirationDateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof BalanceDTO
   */
  balanceAccountNumber?: string;
  balanceAccountNumberIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof BalanceDTO
   */
  balanceIsPrivate?: boolean;
  balanceIsPrivateIsSet: boolean;
  /**
   *
   * @type {BalanceType}
   * @memberof BalanceDTO
   */
  balanceType?: BalanceType;
  balanceTypeIsSet: boolean;
  /**
   *
   * @type {Array<PersonBalanceDTO>}
   * @memberof BalanceDTO
   */
  personBalances?: PersonBalanceDTOTrackedI[];
  personBalancesIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof BalanceDTO
   */
  balanceMinimumCents?: number;
  balanceMinimumCentsIsSet: boolean;
  /**
   *
   * @type {Array<BalanceTransactionWithPaymentDTO>}
   * @memberof BalanceDTO
   */
  balanceTransactions?: BalanceTransactionWithPaymentDTOTrackedI[];
  balanceTransactionsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof BalanceDTO
   */
  balanceAmountCurrent?: number;
  balanceAmountCurrentIsSet: boolean;
}

transformDatesMap.set("BalanceDTO", function (model: BalanceDTO) {
  if (typeof model.balanceExpirationDate == "string")
    model.balanceExpirationDate = new Date(model.balanceExpirationDate);
  const transformDatespersonBalances =
    transformDatesMap.get("PersonBalanceDTO");
  if (transformDatespersonBalances) {
    model.personBalances?.forEach((sub) => {
      transformDatespersonBalances(sub);
    });
  }
  const transformDatesbalanceTransactions = transformDatesMap.get(
    "BalanceTransactionWithPaymentDTO",
  );
  if (transformDatesbalanceTransactions) {
    model.balanceTransactions?.forEach((sub) => {
      transformDatesbalanceTransactions(sub);
    });
  }
});

export type BalanceDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  balanceName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  balanceExpirationDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  balanceAccountNumber: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  balanceIsPrivate: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  balanceType: PropertyMeta<BalanceTypeMetaI>;
  //isDate: false
  //isDatetime: false
  personBalances: PropertyMeta<PersonBalanceDTOMetaI>;
  //isDate: false
  //isDatetime: false
  balanceMinimumCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  balanceTransactions: PropertyMeta<BalanceTransactionWithPaymentDTOMetaI>;
  //isDate: false
  //isDatetime: false
  balanceAmountCurrent: PropertyMeta<MetaTypeBase<number>>;
}>;

export var BalanceDTOMeta: BalanceDTOMetaI = {} as BalanceDTOMetaI;
BalanceDTOMeta = typeMeta("BalanceDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  balanceName: propertyMeta(
    "balanceName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  balanceExpirationDate: propertyMeta(
    "balanceExpirationDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  balanceAccountNumber: propertyMeta(
    "balanceAccountNumber",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  balanceIsPrivate: propertyMeta(
    "balanceIsPrivate",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  balanceType: propertyMeta("balanceType", false, true, false, BalanceTypeMeta),
  personBalances: propertyMeta(
    "personBalances",
    true,
    false,
    false,
    PersonBalanceDTOMeta,
  ),
  balanceMinimumCents: propertyMeta(
    "balanceMinimumCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  balanceTransactions: propertyMeta(
    "balanceTransactions",
    true,
    false,
    false,
    BalanceTransactionWithPaymentDTOMeta,
  ),
  balanceAmountCurrent: propertyMeta(
    "balanceAmountCurrent",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = BalanceDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([BalanceInternalMeta]);
  metaI.isDeleted.inheritedFrom = BalanceInternalMeta.isDeleted;
  metaI.isNew.inheritedFrom = BalanceInternalMeta.isNew;
  metaI.assignId.inheritedFrom = BalanceInternalMeta.assignId;
  metaI.balanceName.inheritedFrom = BalanceInternalMeta.balanceName;
  metaI.balanceExpirationDate.inheritedFrom =
    BalanceInternalMeta.balanceExpirationDate;
  metaI.balanceAccountNumber.inheritedFrom =
    BalanceInternalMeta.balanceAccountNumber;
  metaI.balanceIsPrivate.inheritedFrom = BalanceInternalMeta.balanceIsPrivate;
  metaI.balanceType.inheritedFrom = BalanceInternalMeta.balanceType;
  metaI.personBalances.inheritedFrom = BalanceInternalMeta.personBalances;
  metaI.balanceMinimumCents.inheritedFrom =
    BalanceInternalMeta.balanceMinimumCents;
  metaI.balanceTransactions.inheritedFrom =
    BalanceInternalMeta.balanceTransactions;
});

export class BalanceDTOTracked
  extends BalanceInternalTracked
  implements BalanceDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  balanceName__I?: string = undefined;
  balanceNameIsSet: boolean = false;
  set balanceName(v: undefined | string) {
    if (v !== undefined) {
      this.balanceName__I = v;
      this.balanceNameIsSet = true;
    } else {
      this.balanceName__I = v || undefined;
      this.balanceNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get balanceName() {
    return this.balanceName__I;
  }
  balanceExpirationDate__I?: Date = undefined;
  balanceExpirationDateIsSet: boolean = false;
  set balanceExpirationDate(v: undefined | Date) {
    if (v !== undefined) {
      this.balanceExpirationDate__I = v;
      this.balanceExpirationDateIsSet = true;
    } else {
      this.balanceExpirationDate__I = v || undefined;
      this.balanceExpirationDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get balanceExpirationDate() {
    return this.balanceExpirationDate__I;
  }
  balanceAccountNumber__I?: string = undefined;
  balanceAccountNumberIsSet: boolean = false;
  set balanceAccountNumber(v: undefined | string) {
    if (v !== undefined) {
      this.balanceAccountNumber__I = v;
      this.balanceAccountNumberIsSet = true;
    } else {
      this.balanceAccountNumber__I = v || undefined;
      this.balanceAccountNumberIsSet = false;
    }
    this.changeTracker = true;
  }
  get balanceAccountNumber() {
    return this.balanceAccountNumber__I;
  }
  balanceIsPrivate__I?: boolean = undefined;
  balanceIsPrivateIsSet: boolean = false;
  set balanceIsPrivate(v: undefined | boolean) {
    if (v !== undefined) {
      this.balanceIsPrivate__I = v;
      this.balanceIsPrivateIsSet = true;
    } else {
      this.balanceIsPrivate__I = v || undefined;
      this.balanceIsPrivateIsSet = false;
    }
    this.changeTracker = true;
  }
  get balanceIsPrivate() {
    return this.balanceIsPrivate__I;
  }
  balanceType__I?: BalanceType = undefined;
  balanceTypeIsSet: boolean = false;
  set balanceType(v: undefined | BalanceType) {
    if (v !== undefined) {
      this.balanceType__I = v;
      this.balanceTypeIsSet = true;
    } else {
      this.balanceType__I = v || undefined;
      this.balanceTypeIsSet = true;
    }
    this.changeTracker = true;
  }
  get balanceType() {
    return this.balanceType__I;
  }
  personBalances__I?: PersonBalanceDTOTracked[] = undefined;
  personBalancesIsSet: boolean = false;
  set personBalances(v: undefined | PersonBalanceDTOTracked[]) {
    if (v !== undefined) {
      this.personBalances__I = v;
      this.personBalancesIsSet = true;
    } else {
      this.personBalances__I = v || undefined;
      this.personBalancesIsSet = false;
    }
    this.changeTracker = true;
  }
  get personBalances() {
    return this.personBalances__I;
  }
  balanceMinimumCents__I?: number = undefined;
  balanceMinimumCentsIsSet: boolean = false;
  set balanceMinimumCents(v: undefined | number) {
    if (v !== undefined) {
      this.balanceMinimumCents__I = v;
      this.balanceMinimumCentsIsSet = true;
    } else {
      this.balanceMinimumCents__I = v || undefined;
      this.balanceMinimumCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get balanceMinimumCents() {
    return this.balanceMinimumCents__I;
  }
  balanceTransactions__I?: BalanceTransactionWithPaymentDTOTracked[] =
    undefined;
  balanceTransactionsIsSet: boolean = false;
  set balanceTransactions(
    v: undefined | BalanceTransactionWithPaymentDTOTracked[],
  ) {
    if (v !== undefined) {
      this.balanceTransactions__I = v;
      this.balanceTransactionsIsSet = true;
    } else {
      this.balanceTransactions__I = v || undefined;
      this.balanceTransactionsIsSet = false;
    }
    this.changeTracker = true;
  }
  get balanceTransactions() {
    return this.balanceTransactions__I;
  }
  balanceAmountCurrent__I?: number = undefined;
  balanceAmountCurrentIsSet: boolean = false;
  set balanceAmountCurrent(v: undefined | number) {
    if (v !== undefined) {
      this.balanceAmountCurrent__I = v;
      this.balanceAmountCurrentIsSet = true;
    } else {
      this.balanceAmountCurrent__I = v || undefined;
      this.balanceAmountCurrentIsSet = false;
    }
    this.changeTracker = true;
  }
  get balanceAmountCurrent() {
    return this.balanceAmountCurrent__I;
  }
  constructor(config?: BalanceDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.personBalances?.forEach((a) => a.setIds());

    this.balanceTransactions?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: BalanceDTOOptional,
    options?: AssignOptions,
  ): BalanceDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.balanceName &&
      this.balanceNameApplyFilter(optionsRequired.filter)
    ) {
      this.balanceName = config.balanceName;
      if (optionsRequired.unassign) this.balanceNameIsSet = false;
      else this.balanceNameIsSet = true;
    }
    if (
      config.balanceExpirationDate &&
      this.balanceExpirationDateApplyFilter(optionsRequired.filter)
    ) {
      this.balanceExpirationDate = config.balanceExpirationDate;
      if (optionsRequired.unassign) this.balanceExpirationDateIsSet = false;
      else this.balanceExpirationDateIsSet = true;
    }
    if (
      config.balanceAccountNumber &&
      this.balanceAccountNumberApplyFilter(optionsRequired.filter)
    ) {
      this.balanceAccountNumber = config.balanceAccountNumber;
      if (optionsRequired.unassign) this.balanceAccountNumberIsSet = false;
      else this.balanceAccountNumberIsSet = true;
    }
    if (
      config.balanceIsPrivate &&
      this.balanceIsPrivateApplyFilter(optionsRequired.filter)
    ) {
      this.balanceIsPrivate = config.balanceIsPrivate;
      if (optionsRequired.unassign) this.balanceIsPrivateIsSet = false;
      else this.balanceIsPrivateIsSet = true;
    }
    if (
      config.balanceType &&
      this.balanceTypeApplyFilter(optionsRequired.filter)
    ) {
      this.balanceType = config.balanceType;
      if (optionsRequired.unassign) this.balanceTypeIsSet = false;
      else this.balanceTypeIsSet = true;
    }
    if (
      config.personBalances &&
      this.personBalancesApplyFilter(optionsRequired.filter)
    ) {
      this.personBalances = config.personBalances?.map(
        (a) => new PersonBalanceDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.personBalancesIsSet = false;
      else this.personBalancesIsSet = true;
    }
    if (
      config.balanceMinimumCents &&
      this.balanceMinimumCentsApplyFilter(optionsRequired.filter)
    ) {
      this.balanceMinimumCents = config.balanceMinimumCents;
      if (optionsRequired.unassign) this.balanceMinimumCentsIsSet = false;
      else this.balanceMinimumCentsIsSet = true;
    }
    if (
      config.balanceTransactions &&
      this.balanceTransactionsApplyFilter(optionsRequired.filter)
    ) {
      this.balanceTransactions = config.balanceTransactions?.map(
        (a) => new BalanceTransactionWithPaymentDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.balanceTransactionsIsSet = false;
      else this.balanceTransactionsIsSet = true;
    }
    if (
      config.balanceAmountCurrent &&
      this.balanceAmountCurrentApplyFilter(optionsRequired.filter)
    ) {
      this.balanceAmountCurrent = config.balanceAmountCurrent;
      if (optionsRequired.unassign) this.balanceAmountCurrentIsSet = false;
      else this.balanceAmountCurrentIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): BalanceDTOTrackedI {
    const cloned = {} as BalanceDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.balanceNameIsSetDeep() &&
      this.balanceNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.balanceNameIsSet = true;
      cloned.balanceName = this.balanceName;
    } else {
      //cloned.balanceNameIsSet = false
    }
    if (
      this.balanceExpirationDateIsSetDeep() &&
      this.balanceExpirationDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.balanceExpirationDateIsSet = true;
      cloned.balanceExpirationDate = this.balanceExpirationDate;
    } else {
      //cloned.balanceExpirationDateIsSet = false
    }
    if (
      this.balanceAccountNumberIsSetDeep() &&
      this.balanceAccountNumberApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.balanceAccountNumberIsSet = true;
      cloned.balanceAccountNumber = this.balanceAccountNumber;
    } else {
      //cloned.balanceAccountNumberIsSet = false
    }
    if (
      this.balanceIsPrivateIsSetDeep() &&
      this.balanceIsPrivateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.balanceIsPrivateIsSet = true;
      cloned.balanceIsPrivate = this.balanceIsPrivate;
    } else {
      //cloned.balanceIsPrivateIsSet = false
    }
    if (
      this.balanceTypeIsSetDeep() &&
      this.balanceTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.balanceTypeIsSet = true;
      cloned.balanceType = this.balanceType;
    } else {
      //cloned.balanceTypeIsSet = false
    }
    if (
      this.personBalancesIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.personBalancesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personBalancesIsSet = true;
      cloned.personBalances = this.personBalances
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.personBalancesIsSet = false
    }
    if (
      this.balanceMinimumCentsIsSetDeep() &&
      this.balanceMinimumCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.balanceMinimumCentsIsSet = true;
      cloned.balanceMinimumCents = this.balanceMinimumCents;
    } else {
      //cloned.balanceMinimumCentsIsSet = false
    }
    if (
      this.balanceTransactionsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.balanceTransactionsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.balanceTransactionsIsSet = true;
      cloned.balanceTransactions = this.balanceTransactions
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.balanceTransactionsIsSet = false
    }
    if (
      this.balanceAmountCurrentIsSetDeep() &&
      this.balanceAmountCurrentApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.balanceAmountCurrentIsSet = true;
      cloned.balanceAmountCurrent = this.balanceAmountCurrent;
    } else {
      //cloned.balanceAmountCurrentIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): BalanceDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.balanceNameApplyFilter(filter)) this.balanceNameIsSet = false;

    if (!this.balanceExpirationDateApplyFilter(filter))
      this.balanceExpirationDateIsSet = false;

    if (!this.balanceAccountNumberApplyFilter(filter))
      this.balanceAccountNumberIsSet = false;

    if (!this.balanceIsPrivateApplyFilter(filter))
      this.balanceIsPrivateIsSet = false;

    if (!this.balanceTypeApplyFilter(filter)) this.balanceTypeIsSet = false;

    if (!this.personBalancesApplyFilter(filter))
      this.personBalancesIsSet = false;

    this.personBalances?.forEach((a) => a.unassignAll(filter));
    if (!this.balanceMinimumCentsApplyFilter(filter))
      this.balanceMinimumCentsIsSet = false;

    if (!this.balanceTransactionsApplyFilter(filter))
      this.balanceTransactionsIsSet = false;

    this.balanceTransactions?.forEach((a) => a.unassignAll(filter));
    if (!this.balanceAmountCurrentApplyFilter(filter))
      this.balanceAmountCurrentIsSet = false;

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceDTOMeta.isDeleted,
      BalanceDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(BalanceDTOMeta.isNew, BalanceDTOMeta, this.isNew, this);
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(BalanceDTOMeta.assignId, BalanceDTOMeta, this.assignId, this);
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  balanceNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceDTOMeta.balanceName,
      BalanceDTOMeta,
      this.balanceName,
      this,
    );
  }
  balanceNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.balanceNameIsSet && this.balanceNameApplyFilter(filter))
      return true;

    return false;
  }
  balanceExpirationDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceDTOMeta.balanceExpirationDate,
      BalanceDTOMeta,
      this.balanceExpirationDate,
      this,
    );
  }
  balanceExpirationDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.balanceExpirationDateIsSet &&
      this.balanceExpirationDateApplyFilter(filter)
    )
      return true;

    return false;
  }
  balanceAccountNumberApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceDTOMeta.balanceAccountNumber,
      BalanceDTOMeta,
      this.balanceAccountNumber,
      this,
    );
  }
  balanceAccountNumberIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.balanceAccountNumberIsSet &&
      this.balanceAccountNumberApplyFilter(filter)
    )
      return true;

    return false;
  }
  balanceIsPrivateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceDTOMeta.balanceIsPrivate,
      BalanceDTOMeta,
      this.balanceIsPrivate,
      this,
    );
  }
  balanceIsPrivateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.balanceIsPrivateIsSet && this.balanceIsPrivateApplyFilter(filter))
      return true;

    return false;
  }
  balanceTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceDTOMeta.balanceType,
      BalanceDTOMeta,
      this.balanceType,
      this,
    );
  }
  balanceTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.balanceTypeIsSet && this.balanceTypeApplyFilter(filter))
      return true;

    return false;
  }
  personBalancesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceDTOMeta.personBalances,
      BalanceDTOMeta,
      this.personBalances,
      this,
    );
  }
  personBalancesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personBalancesIsSet && this.personBalancesApplyFilter(filter))
      return true;

    return this.personBalances?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  balanceMinimumCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceDTOMeta.balanceMinimumCents,
      BalanceDTOMeta,
      this.balanceMinimumCents,
      this,
    );
  }
  balanceMinimumCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.balanceMinimumCentsIsSet &&
      this.balanceMinimumCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  balanceTransactionsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceDTOMeta.balanceTransactions,
      BalanceDTOMeta,
      this.balanceTransactions,
      this,
    );
  }
  balanceTransactionsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.balanceTransactionsIsSet &&
      this.balanceTransactionsApplyFilter(filter)
    )
      return true;

    return this.balanceTransactions?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  balanceAmountCurrentApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceDTOMeta.balanceAmountCurrent,
      BalanceDTOMeta,
      this.balanceAmountCurrent,
      this,
    );
  }
  balanceAmountCurrentIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.balanceAmountCurrentIsSet &&
      this.balanceAmountCurrentApplyFilter(filter)
    )
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.balanceNameIsSetDeep(filter)) return true;
    if (this.balanceExpirationDateIsSetDeep(filter)) return true;
    if (this.balanceAccountNumberIsSetDeep(filter)) return true;
    if (this.balanceIsPrivateIsSetDeep(filter)) return true;
    if (this.balanceTypeIsSetDeep(filter)) return true;
    if (this.personBalancesIsSetDeep(filter)) return true;
    if (this.balanceMinimumCentsIsSetDeep(filter)) return true;
    if (this.balanceTransactionsIsSetDeep(filter)) return true;
    if (this.balanceAmountCurrentIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
